<template>
    <div :style="styles.container" class="confirmation-modal-template">
        <div :style="styles.content" class="confirmation-modal-content">
            <header :style="styles.header" class="confirmation-modal-header">
                <slot name="header"></slot>
            </header>
            <main :style="styles.main" class="confirmation-modal-main">
                <slot name="main"></slot>
            </main>
            <footer :style="styles.footer" class="confirmation-modal-footer">
                <slot name="footer"></slot>
            </footer>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'ConfirmationModal',
        props: {
            styles: {
                required: false,
                default: () => ({})
            }
        }
    }
</script>
<style lang="scss" scoped>
    .confirmation-modal-template {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 16px;
    }
</style>
